import React, { useEffect, useState } from 'react';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { Button, Col, Form, Input, Modal, Row, Spin, Table, TableColumnsType, Typography } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import Title from 'antd/es/typography/Title';
import { getKrConfirmComplete, reset, saveComplete, saveDraft } from 'app/entities/checkIn/checkIn.reducer';
import { Container } from 'reactstrap';
import { displayPercent } from 'app/shared/util/percent';
const { Text } = Typography;

type IConfirmCompleteProps = {
  isOpen: boolean;
  onClose: (isReload?: boolean) => void;
};

export const ConfirmComplete = ({ isOpen, onClose }: IConfirmCompleteProps) => {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const filters = useAppSelector(state => state.filters.orgCheckIn);
  const updating = useAppSelector(state => state.checkIn.updating);
  const loading = useAppSelector(state => state.checkIn.loading);
  const updateSuccess = useAppSelector(state => state.checkIn.updateSuccess);

  const [data, setData] = useState(null);

  const columnsResult: TableColumnsType<any> = [
    {
      key: 'workStatusName',
      dataIndex: 'workStatusName',
      width: 200,
    },
    {
      title: 'Qúy I',
      children: [
        {
          title: 'Số KR',
          key: 'firstQuarterCount',
          align: 'center',
          dataIndex: 'firstQuarterCount',
        },
        {
          title: 'Tỷ lệ',
          key: 'firstQuarterProportion',
          align: 'center',
          dataIndex: 'firstQuarterProportion',
          render: item => {
            const value = displayPercent(item);
            return value === 0 ? '0%' : `${parseFloat(value.toFixed(2))}%`;
          },
        },
      ],
    },
    {
      title: 'Qúy II',
      children: [
        {
          title: 'Số KR',
          key: 'secondQuarterCount',
          align: 'center',
          dataIndex: 'secondQuarterCount',
        },
        {
          title: 'Tỷ lệ',
          key: 'secondQuarterProportion',
          align: 'center',
          dataIndex: 'secondQuarterProportion',
          render: item => {
            const value = displayPercent(item);
            return value === 0 ? '0%' : `${parseFloat(value.toFixed(2))}%`;
          },
        },
      ],
    },
    {
      title: 'Tổng',
      children: [
        {
          title: 'Số KR',
          key: 'totalCount',
          align: 'center',
          dataIndex: 'totalCount',
        },
        {
          title: 'Tỷ lệ',
          key: 'totalProportion',
          align: 'center',
          dataIndex: 'totalProportion',
          render: item => {
            const value = displayPercent(item);
            return value === 0 ? '0%' : `${parseFloat(value.toFixed(2))}%`;
          },
        },
      ],
    },
  ];

  useEffect(() => {
    if (filters?.planPeriodId) innitData();
  }, [filters]);

  const innitData = async () => {
    const response = await dispatch(
      getKrConfirmComplete({ planPeriodId: filters?.planPeriodId, checkinType: 1, partyId: filters?.accountableId }),
    );
    if (response && response.payload) {
      const result = response.payload as any;
      if (result.data) {
        setData(result.data);
        form.setFieldsValue({
          adjustmentNote: '.',
          successNote: '.',
          failNote: '.',
          issue: '.',
          solution: '.',
        });
      }
    }
  };

  useEffect(() => {
    if (updateSuccess) {
      handleClose(updateSuccess);
    }
  }, [updateSuccess]);

  const handleSubmit = values => {
    (values.planPeriodId = filters?.planPeriodId),
      (values.reportScheduleId = data.reportScheduleId),
      (values.partyId = filters?.accountableId),
      dispatch(saveComplete(values));
  };

  const handleSaveDraft = () => {
    form.validateFields().then(values => {
      (values.planPeriodId = filters?.planPeriodId),
        (values.reportScheduleId = data.reportScheduleId),
        (values.partyId = filters?.accountableId),
        dispatch(saveDraft(values));
    }).catch(() => { return; });
  };

  const handleClose = (reload = false) => {
    onClose(reload);
    dispatch(reset())
  };

  return (
    <Modal
      width={1150}
      open={isOpen}
      footer={null}
      onCancel={() => {
        handleClose();
      }}
    >
      <Container className="form">
        <Spin spinning={loading} delay={300}>
          <Form size="large" form={form} onFinish={handleSubmit} layout="vertical">
            <Title level={3}>{`Xác nhận hoàn thành check in ${filters?.accountableName ? `- ${filters?.accountableName}` : ''}`}</Title>
            <Row>
              <Col>
                <Form.Item label="Kỳ báo cáo">
                  <Input disabled value={data?.reportScheduleName} />
                </Form.Item>
              </Col>
            </Row>
            <Row className='my-3'>
              <Col md={24}>
                <span className="fw-bold h5">KẾT QUẢ THỰC HIỆN MỤC TIÊU</span>
              </Col>
            </Row>
            <Row>
              <Col md={24}>
                <Table
                  pagination={false}
                  bordered
                  dataSource={data?.workLoads}
                  columns={columnsResult}
                  className="w-100"
                  rowClassName={(record, index) => {
                    return index === data?.workLoads.length - 1 ? 'fw-bold' : '';
                  }}
                />
              </Col>
            </Row>

            <Row className='my-3'>
              <Col md={24}>
                <span className="fw-bold">Điểm đánh giá hoàn thành mục tiêu</span>
              </Col>
            </Row>
            <Row>
              <Col md={24}>
                <table className="custom-table" style={{ borderTop: '1px solid #f0f0f0', borderLeft: '1px solid #f0f0f0' }}>
                  <tr>
                    <td>Quý I</td>
                    <td>{`${displayPercent(data?.firstQuarterRating).toFixed(2)}%`}</td>
                  </tr>
                  <tr>
                    <td>Quý II</td>
                    <td>{`${displayPercent(data?.secondQuarterRating).toFixed(2)}%`}</td>
                  </tr>
                  <tr>
                    <td>Trung bình</td>
                    <td>{`${displayPercent(data?.avgRating).toFixed(2)}%`}</td>
                  </tr>
                </table>
              </Col>
            </Row>

            <Form.Item>
              <Row className="action" justify="end">
                <Col>
                  <Button type="primary" htmlType="submit" disabled={updating}>
                    Xác nhận hoàn thành
                  </Button>
                </Col>
                <Col>
                  <Button
                    onClick={() => {
                      handleClose();
                    }}
                  >
                    Hủy
                  </Button>
                </Col>
              </Row>
            </Form.Item>
          </Form>
        </Spin>
      </Container>
    </Modal>
  );
};

export default ConfirmComplete;
